import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";

const FetchNpsAdminAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/nps/admin-dashboard`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_NPS_ADMIN_ACTION' }, data);
        dispatch(resData);
    }
}

export { FetchNpsAdminAction }